"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthFlowHeader } from "../../auth-flow-header";
import React, { useEffect } from "react";
import { FaCakeCandles } from "react-icons/fa6";
import { Button } from "@/components/ui";
import { Skeleton } from "@/components/ui/skeleton";
import { formatDate, formatName } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { SelfSchedulePatient } from "@/types/self-schedule";
import { PhoneAuthStep, usePhoneAuth } from "./phone-auth-context";
type PatientPickerProps = {
  className?: string;
};
export function PatientPicker(t0) {
  const $ = _c(32);
  const {
    className
  } = t0;
  const {
    state,
    actions
  } = usePhoneAuth();
  let t1;
  if ($[0] !== actions) {
    t1 = patient => {
      actions.selectPatient(patient);
    };
    $[0] = actions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSelectPatient = t1;
  let t2;
  let t3;
  if ($[2] !== actions || $[3] !== state.candidates || $[4] !== state.isClaiming || $[5] !== state.step) {
    t2 = () => {
      if (state.step !== PhoneAuthStep.PICK_PATIENT) {
        return;
      }
      if (state.isClaiming) {
        return;
      }
      const patients = state.candidates;
      if (patients.length === 1 && !patients[0]?.hasPortalAccount && !patients[0]?.firstName?.trim() && !patients[0]?.lastName?.trim()) {
        actions.selectPatient(patients[0]);
      }
    };
    t3 = [state.step, state.candidates, state.isClaiming, actions];
    $[2] = actions;
    $[3] = state.candidates;
    $[4] = state.isClaiming;
    $[5] = state.step;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  if (state.step !== PhoneAuthStep.PICK_PATIENT) {
    return null;
  }
  const patients_0 = state.candidates;
  const isClaiming = state.isClaiming;
  if (state.isLoadingCandidates) {
    let t4;
    if ($[8] !== className) {
      t4 = cx(className);
      $[8] = className;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="space-y-2"><Skeleton className="h-7 w-40" /><Skeleton className="h-4 w-72" /></div>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="space-y-3"><Skeleton className="h-16 w-full" /><Skeleton className="h-16 w-full" /></div>;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t4) {
      t7 = <div className={t4} role="status" aria-live="polite" aria-label={"Loading patients\u2026"}>{t5}{t6}</div>;
      $[12] = t4;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  }
  if (patients_0.length === 0) {
    let t4;
    if ($[14] !== className) {
      t4 = cx(className, "space-y-4");
      $[14] = className;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="space-y-2"><h2 className="text-h1">No matching patient</h2><p className="text-foreground-secondary">We couldn't find a patient under this phone number.</p></div>;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== actions.startNewPatient) {
      t6 = <Button variant="primary" onClick={actions.startNewPatient} className="w-full">Create new patient</Button>;
      $[17] = actions.startNewPatient;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    let t7;
    if ($[19] !== t4 || $[20] !== t6) {
      t7 = <div className={t4}>{t5}{t6}</div>;
      $[19] = t4;
      $[20] = t6;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    return t7;
  }
  let t4;
  if ($[22] !== className) {
    t4 = cx(className);
    $[22] = className;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== actions.startNewPatient || $[25] !== handleSelectPatient || $[26] !== isClaiming || $[27] !== patients_0) {
    t5 = patients_0.length > 1 ? <><div className="space-y-2"><AuthFlowHeader title="welcome back!" description="There are multiple patients with this phone number. Please select the correct one:" /></div><div className="max-h-72 space-y-3 overflow-y-auto">{patients_0.map(patient_0 => <div key={patient_0.id} onClick={() => {
          if (isClaiming) {
            return;
          }
          handleSelectPatient(patient_0);
        }} aria-disabled={isClaiming} className={cx("w-full rounded-lg border p-4 text-left transition-all hover:border-primary hover:bg-accent-50 focus:border-primary focus:bg-accent-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-20", isClaiming ? "cursor-not-allowed opacity-60" : "cursor-pointer")}><div className="flex items-center justify-between"><div><div className="font-medium text-foreground">{formatName(patient_0.firstName, patient_0.lastName)}</div>{patient_0.email && <div className="text-body text-muted-foreground">{patient_0.email}</div>}{patient_0.dateOfBirth && <div className="flex items-center text-body text-muted-foreground"><FaCakeCandles className="mr-2" />{" "}{formatDate(patient_0.dateOfBirth)}</div>}</div></div></div>)}</div><p className="text-foreground-secondary">Don't see your name?{" "}<Button variant="ghost" onClick={actions.startNewPatient} className="m-0 h-fit w-fit p-0 text-primary underline">Create new patient</Button></p></> : <><div className="space-y-2"><AuthFlowHeader title="Welcome Back!" description={`Are you ${formatName(patients_0[0].firstName, patients_0[0].lastName)}?`} /></div><div className="space-y-2"><Button variant="primary" onClick={() => handleSelectPatient(patients_0[0])} disabled={isClaiming} className="w-full">{isClaiming ? "Linking\u2026" : "Yes, that's me"}</Button><Button variant="secondary" onClick={actions.startNewPatient} disabled={isClaiming} className="w-full">No, create new patient</Button></div></>;
    $[24] = actions.startNewPatient;
    $[25] = handleSelectPatient;
    $[26] = isClaiming;
    $[27] = patients_0;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  let t6;
  if ($[29] !== t4 || $[30] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
}